import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card, CardContent } from "./ui/card";
import { Star, Quote } from "lucide-react";

export default function TestimonialCarousel({ limit = 5, title = "What our members say" }) {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/testimonials");
        setItems((data || []).slice(0, limit));
      } catch {
        /* ignore */
      }
    })();
  }, [limit]);

  useEffect(() => {
    if (items.length < 2) return;
    const id = setInterval(() => setActive((a) => (a + 1) % items.length), 6000);
    return () => clearInterval(id);
  }, [items.length]);

  if (items.length === 0) return null;

  return (
    <section data-testid="testimonials-section">
      <div className="flex items-end justify-between gap-3 mb-4">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-emerald-700 font-semibold">
            Real results
          </div>
          <h2 className="font-display text-2xl sm:text-3xl text-emerald-950 mt-1">{title}</h2>
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {items.map((t, idx) => (
          <Card
            key={t.id}
            className={`rounded-2xl border-emerald-100 bg-white ${
              idx === active ? "shadow-md" : "shadow-sm"
            } transition-shadow`}
            data-testid={`testimonial-${t.id}`}
          >
            <CardContent className="p-6">
              <Quote className="w-6 h-6 text-amber-500" />
              <p className="text-emerald-950 mt-3 leading-relaxed">
                {t.quote}
              </p>
              <div className="mt-4 flex items-center gap-1">
                {Array.from({ length: t.rating || 5 }).map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <div className="mt-3 flex items-center justify-between">
                <div>
                  <div className="font-medium text-emerald-950 text-sm">{t.name}</div>
                  <div className="text-xs text-emerald-900/60">
                    {t.city ? `${t.city} · ` : ""}
                    {t.condition || ""}
                  </div>
                </div>
                {t.before_after ? (
                  <div className="text-[11px] uppercase tracking-[0.2em] text-amber-700 font-semibold bg-amber-50 px-2 py-1 rounded-full">
                    {t.before_after}
                  </div>
                ) : null}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
